import { useRefinementList } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { useSearchDictionary } from '../../../util';
import { useState } from 'react';
import ArroweExpand from 'components/helpers/SvgIcon/icons/arrow-expand';
import ArrowCollapse from 'components/helpers/SvgIcon/icons/arrow-collape';

const YearFacet = () => {
  const [isOpen, setOpen] = useState(true);
  const dict = useSearchDictionary();
  const yearRefineList = useRefinementList({
    attribute: 'year',
    showMore: true,
    limit: 5,
    sortBy: ['name:desc'],
  });

  const handleTypeSelect = (facet: string) => {
    yearRefineList.refine(facet);
  };

  yearRefineList.items.sort((a, b) => {
    return Number(b.value) - Number(a.value);
  });

  return (
    <div>
      <div
        className={classnames(
          'text-blue-night',
          'mb-4',
          'flex',
          'w-full',
          'justify-between',
          'lg:text-lg'
        )}
      >
        <button
          type="button"
          onClick={() => setOpen(!isOpen)}
          className={classnames('flex', 'w-full', 'justify-between', 'text-body', 'font-medium')}
        >
          <span>{dict.year}</span>
          <span>
            {isOpen ? (
              <ArroweExpand className={classnames('text-blue-morning')} />
            ) : (
              <ArrowCollapse className={classnames('text-blue-morning')} />
            )}
          </span>
        </button>
      </div>
      {isOpen && (
        <>
          {yearRefineList.items.map((x) => {
            const checkboxId = x.value.replace(/\s+/g, '');
            return (
              <div key={checkboxId} className={classnames('flex', 'w-full', 'pb-4', 'text-black')}>
                <input
                  type="checkbox"
                  name={x.value}
                  value={x.value}
                  id={checkboxId}
                  checked={x.isRefined}
                  onChange={(e) => handleTypeSelect(e.currentTarget.value)}
                  className={classnames('min-w-[24px]', 'h-6', 'accent-blue-morning')}
                />
                <label htmlFor={checkboxId} className={classnames('flex', 'w-full')}>
                  <span className={classnames('pl-2', 'w-full')}>{x.label}</span>
                  <span className={classnames('pr-0.5', 'text-right')}>{x.count}</span>
                </label>
              </div>
            );
          })}
          {yearRefineList.canToggleShowMore && (
            <button
              type="button"
              className={classnames('text-theme-btn-link-text', 'underline')}
              onClick={() => {
                yearRefineList.toggleShowMore();
              }}
            >
              {yearRefineList.isShowingMore ? 'Show Less' : 'Show More'}
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default YearFacet;
